import React, { useRef, useEffect, useState } from 'react';
import * as $ from 'jquery';
import useHttp from '../../../../hook/use-http';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { INIT_STATE_SELECTS, INDEX } from "../../../../constants/driveglobalfilterinitalstates_bus";
import CustomSelect_Simulator from "./CustomSelect_Simulator"
import { BsFillSkipBackwardBtnFill } from "react-icons/bs";
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCityDepo } from '../../../../redux/cityDepoSlice';
import { decodeToken } from "react-jwt";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { Calendar, Download } from 'lucide-react';
import styles from './MileageSimulatorTab.module.css';
import "../MileageSaarathiTab_ace/Filter/styles.css"
import "../MileageSaarathiTab_ace/Filter/Filter_Bus.module.css"


const CascadingSelects = (props) => {
  const { sendReq: fetchData } = useHttp();

  const { setGlobalFilter } = props

  const [filterdata, setFilterdata] = useState({
    CITY: [],
    DEPO: [],
    ROUTE: []
  });

  const [options, setOptions] = useState({
    CITY: [],
    DEPO: [],
    ROUTE: []
  });

  const [selected, setSelected] = useState({
    CITY: null,
    DEPO: null,
    ROUTE: []
  });

  useEffect(() => {
    setGlobalFilter(prev => ({
      ...prev,
      VIN_NUM: [],
      REG_NUM: [],
      CITY: filterdata.CITY,
      DEPO: filterdata.DEPO,
      ROUTE: filterdata.ROUTE,
    }))
  }, [filterdata])


  useEffect(() => {
    const url = `${API_URL_MAIN}Ace_simulator/simulator_city_filter`;
    fetchData({ url, body: { IND: "CITY_INDEX", filterdata } }, (data) => {
      const buckets = data?.unique_city?.buckets || [];
      const cityOptions = buckets.map((item) => ({
        id: item.key.city,
        value: item.key.city,
        label: item.key.city.toString(),
      }));
      setOptions((prev) => ({ ...prev, CITY: cityOptions }));
    });
  }, []);

  // ✅ Fetch DEPO when CITY is selected
  useEffect(() => {
    if (!filterdata.CITY.length) return;
    const url = `${API_URL_MAIN}Ace_simulator/simulator_depot_filter`;
    fetchData({ url, body: { IND: "DEPO_INDEX", filterdata } }, (data) => {
      const buckets = data?.unique_depo?.buckets || [];
      const depoOptions = buckets.map((item) => ({
        id: item.key.route,
        value: item.key.route,
        label: item.key.route.toString(),
      }));
      setOptions((prev) => ({ ...prev, DEPO: depoOptions }));
    });
  }, [filterdata.CITY]);

  // ✅ Fetch ROUTE when DEPO is selected
  useEffect(() => {
    if (!filterdata.DEPO.length) return;
    const url = `${API_URL_MAIN}Ace_mileage_sarathi/route`;
    fetchData({ url, body: { IND: "ROUTE_INDEX", filterdata } }, (data) => {
      const buckets = data?.unique_depo?.buckets || [];
      const routeOptions = buckets.map((item) => ({
        id: item.key.route,
        value: item.key.route,
        label: item.key.route.toString(),
      }));
      const finalOptions = routeOptions.length > 0 ? [{ label: "All", value: "*" }, ...routeOptions] : [];
      setOptions((prev) => ({ ...prev, ROUTE: finalOptions }));
      setSelected((prev) => ({ ...prev, ROUTE: finalOptions }));
      setFilterdata((prev) => ({ ...prev, ROUTE: [] }));
    });
  }, [filterdata.DEPO]);

  // const getDropdownLabel = ({ placeholderButtonLabel, value }) => {
  //     if (Array.isArray(value)) {
  //         if (!filterdata.ROUTE?.length) return "Select...";
  //         if (value.some((v) => v.value === "*")) return "All";
  //         return `${value.length} selected`;
  //     }

  //     if (!filterdata.CITY?.length && placeholderButtonLabel === "Select city") return "Select...";
  //     if (!filterdata.DEPO?.length && placeholderButtonLabel === "Select depo") return "Select...";

  //     return value?.label || placeholderButtonLabel || "Select...";
  // };

  const getDropdownLabel = ({ placeholderButtonLabel, value }) => {
    if (Array.isArray(value)) {
      const routeOptions = options.ROUTE.filter(o => o.value !== "*");

      // Show "Select..." if route dropdown is refreshed (after city change) and nothing selected
      if (!value.length) return "Select...";

      const allSelected = value.length === routeOptions.length;

      // If all routes selected (including via manual selection)
      if (value.some(o => o.value === "*") || allSelected) {
        return "All";
      }

      return `${value.length} selected`;
    }

    if (!filterdata.CITY?.length && placeholderButtonLabel === "Select city") return "Select...";
    if (!filterdata.DEPO?.length && placeholderButtonLabel === "Select depo") return "Select...";

    return value?.label || placeholderButtonLabel || "Select...";
  };

  const onChange = (value, event, IND) => {
    if (IND === "CITY_INDEX") {
      const selectedValue = value?.value || "";
      setSelected({ CITY: value, DEPO: null, ROUTE: [] }); // 🔁 Clear previous DEPO & ROUTE
      setFilterdata({ CITY: selectedValue ? [selectedValue] : [], DEPO: [], ROUTE: [] });
      setOptions((prev) => ({ ...prev, DEPO: [], ROUTE: [] }));
    }

    if (IND === "DEPO_INDEX") {
      const selectedValue = value?.value || "";
      setSelected((prev) => ({ ...prev, DEPO: value, ROUTE: [] }));
      setFilterdata((prev) => ({
        ...prev,
        DEPO: selectedValue ? [selectedValue] : [],
        ROUTE: []
      }));
      setOptions((prev) => ({ ...prev, ROUTE: [] }));
    }

    if (IND === "ROUTE_INDEX") {
      const extractedValues = value.map((v) => v.value);
      if (event.option?.value === "*") {
        if (event.action === "select-option") {
          setSelected((prev) => ({ ...prev, ROUTE: options.ROUTE }));
          setFilterdata((prev) => ({ ...prev, ROUTE: [] }));
        } else {
          setSelected((prev) => ({ ...prev, ROUTE: [] }));
          setFilterdata((prev) => ({ ...prev, ROUTE: [] }));
        }
      } else {
        const filtered = value.filter((v) => v.value !== "*");
        setSelected((prev) => ({ ...prev, ROUTE: filtered }));
        setFilterdata((prev) => ({
          ...prev,
          ROUTE: filtered.length === options.ROUTE.length - 1
            ? []
            : filtered.map((v) => v.value)
        }));
      }
    }
  };

  return (
    <div className="row">
      <div className="col-md-4">
        <div className={`mb-1 ${styles.date_range_selection}`}>Select City</div>
        <ReactMultiSelectCheckboxes

          className="react-select-container" classNamePrefix="react-select"
          options={options.CITY}
          value={selected.CITY}
          onChange={(val, evt) => onChange(val, evt, "CITY_INDEX")}
          getDropdownButtonLabel={getDropdownLabel}
          placeholderButtonLabel="Select city"
          isMulti={false}
        />
      </div>

      <div className="col-md-4">
        <div className={`mb-1 ${styles.date_range_selection}`}>Select Depo</div>
        <ReactMultiSelectCheckboxes

          className="react-select-container" classNamePrefix="react-select"
          options={options.DEPO}
          value={selected.DEPO || undefined}
          onChange={(val, evt) => onChange(val, evt, "DEPO_INDEX")}
          getDropdownButtonLabel={getDropdownLabel}
          placeholderButtonLabel="Select depo"
          isMulti={false}
        />
      </div>

      <div className="col-md-4">
        <div className={`mb-1 ${styles.date_range_selection}`}>Select Route</div>
        <ReactMultiSelectCheckboxes

          className="react-select-container" classNamePrefix="react-select"
          options={options.ROUTE}
          value={selected.ROUTE}
          onChange={(val, evt) => onChange(val, evt, "ROUTE_INDEX")}
          getDropdownButtonLabel={getDropdownLabel}
          placeholderButtonLabel="Select route"
          isMulti
        />
      </div>
    </div>
  );
};

export default CascadingSelects;
